import { z } from "zod";

import { zodResolver } from "@hookform/resolvers/zod";

export const MONDAY_BOARD_URL =
  "https://two-ocean-education-partners.monday.com/boards/9193425278/pulses";

export const CREATE_CAMPAIGN_FROM_TEMPLATE_SCHEMA = zodResolver(
  z.object({
    // Step 1 fields - no validation needed (manually blocked by UI)
    strategy: z.string().optional(),
    programType: z.string().optional(),
    transferStudentStatusFlag: z.boolean().default(false),
    campaignObjective: z.string().optional(),
    campaignTemplates: z.array(z.string()).optional(),

    // Step 2 fields - no validation needed (manually blocked by UI)
    templates: z.record(z.string(), z.boolean()).default({}),

    // Step 3 fields
    campaignName: z
      .string()
      .min(1, "Campaign name is required")
      .refine((val) => val.trim().length > 0, {
        message: "Campaign name cannot be empty or only whitespace.",
      }),
    cdnSubdirectoryName: z
      .string()
      .optional()
      .refine(
        (val) => {
          if (val === undefined || val === "") return true;
          return /^[a-zA-Z0-9_-]*$/.test(val);
        },
        {
          message:
            "CDN profile name can only contain letters, numbers, underscores, and dashes (no spaces or special characters).",
        },
      ),
    audiences: z.array(z.string()).optional(),
  }),
);

export const CREATE_CAMPAIGN_FROM_TEMPLATE_STEPS = 3;
